import { LAYERS_UI_CONFIG } from '@/routes/map/constants.tsx';
import { Layer as LayerType } from './types.ts';

export function EiaTransmissionLegend() {
	const stops = LAYERS_UI_CONFIG[LayerType.EiaTransmission].stops;
	return (
		stops && (
			<div className="transmission-legend">
				<h4>Line Voltage</h4>
				<ul>
					{stops.map(item => (
						<li key={item.label} style={{ color: item.color }}>
						<span
							style={{
								display: 'inline-block',
								width: 16,
								height: 16,
								background: item.color,
								marginRight: 8,
								borderRadius: 2,
								border: '1px solid #ccc',
								verticalAlign: 'middle'
							}}
						/>
							{item.label}
						</li>
					))}
				</ul>
			</div>
		)
	);
}
